import { CircularProgress } from "@mui/material";
import Box from "@mui/material/Box";
import { memo, useContext, useState } from "react";
import ConfettiExplosion from "react-confetti-explosion";
import { useDispatch, useSelector } from "react-redux";
import { UserContext } from "../../../../../../App";
import {
  applyCouponcode,
  applyRestaurantCouponcode,
  removecoupon,
} from "../../../../../../config/Services";
import { BootstrapInput } from "../../../../posnavbar/components/addCustomer/components/bootStrapInput";
import { useSnackbar } from "../../../hooks/SnackbarProvider";
import { addcoupon } from "../../redux/Actions/couponActions";
import { getCouponState } from "../../redux/Reducers/couponReducer";
import { getStoreCurrencySymbol } from "../../../../../../utils/currency";
import "./paymentCouponModal.css";

// Drawer width adjusted in paymentCouponModal.css to match reference size: 100% on mobile, 480px on desktop.
// Coupon drawer header styling and wrapper rules are defined in paymentCouponModal.css.
const PaymentCouponModal = ({
  index,
  e,
  setCouponsModal,
  couponText,
  setCouponText,
  couponsData,
  type,
  setShowCoupon,
  drawerMode = false,
}) => {
  const showSnackbar = useSnackbar();
  const { setTotal, setCgst, setSgst, setCouponApplied, setCess } = useContext(UserContext);
  let cartId = localStorage.getItem("CartId");
  const [loader, setLoader] = useState(false);
  const couponData = useSelector(getCouponState);
  const dispatch = useDispatch();
  const defaultImg = "https://i.imgur.com/T1KH34U.png";
  const [isExploding, setIsExploding] = useState(false);
  const [isManualLoading, setIsManualLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const retailType = localStorage.getItem("retailType");

  const confettiOptions = {
    force: 0.4,
    duration: 2200,
    particleSize: 6,
    particleCount: 30,
    width: 400,
  };

  const handleCouponState = (couponId, couponCode = "") => {
    if (!!couponId) {
      setLoader(true);
    }
    let payload = {
      couponId: couponId,
      couponCode: couponCode,
      cartId: cartId,
    };
    if (retailType === "RESTAURANT") {
      applyRestaurantCouponcode(payload)
        .then((res) => {
          if (
            res?.data?.status === "error" ||
            res?.data?.status === "ERROR" ||
            res?.data?.data?.es > 0
          ) {
            return showSnackbar(res?.data?.message || res?.data?.data?.message, "error");
          }
          showSnackbar("Coupons Successfully applied", "success");
          dispatch(addcoupon(res?.data?.data?.data?.cartCoupon));
          localStorage.setItem("cartCoupon", JSON.stringify(res?.data?.data?.data?.cartCoupon));
          setCouponApplied(res?.data?.data?.data?.cartCoupon?.couponValue);
          setCgst(res?.data?.data?.data?.billing?.cgst);
          setSgst(res?.data?.data?.data?.billing?.sgst);
          setCess(res?.data?.data?.data?.billing?.totalCessAmount);
          setIsExploding(true);
          setTotal(res?.data?.data?.data?.billing?.totalCartValue);
          if (type === "RESTAURANT") {
            setShowCoupon(true);
          }
          setCouponsModal(false);
        })
        .catch((err) => {
          showSnackbar(err?.response?.data?.message || err?.message, "error");
          setErrorMsg(err?.response?.data?.message || err?.message);
        })
        .finally(() => {
          setLoader(false);
          setIsManualLoading(false);
        });
    } else {
      applyCouponcode(payload)
        .then((res) => {
          showSnackbar("Coupons Successfully applied", "success");
          dispatch(addcoupon(res?.data?.data?.cartCoupon));
          localStorage.setItem("cartCoupon", JSON.stringify(res?.data?.data?.cartCoupon));
          setCouponApplied(res?.data?.data?.cartCoupon?.couponValue);
          setCgst(res?.data?.data?.billing?.cgst);
          setSgst(res?.data?.data?.billing?.sgst);
          setCess(res?.data?.data?.billing?.totalCessAmount);
          setIsExploding(true);
          setTotal(res?.data?.data?.billing?.totalCartValue);
          if (type === "RESTAURANT") {
            setShowCoupon(true);
          }
          setCouponsModal(false);
        })
        .catch((err) => {
          showSnackbar(err?.response?.data?.message || err?.message, "error");
          setErrorMsg(err?.response?.data?.message || err?.message);
        })
        .finally(() => {
          setLoader(false);
          setIsManualLoading(false);
        });
    }
  };
  const handleRemovecoupon = (couponCode) => {
    setLoader(true);
    removecoupon(cartId)
      .then((res) => {
        showSnackbar("Successfully coupon removed", "success");
        setTotal(res?.data?.data?.billing?.totalCartValue);
        dispatch(addcoupon(res?.data?.data?.billing?.appliedCoupon));
        localStorage.removeItem("cartCoupon");
        if (type === "RESTAURANT") {
          setShowCoupon(true);
        }
        setCouponsModal(false);
      })
      .catch((err) => {
        showSnackbar(err?.response?.data?.message || err?.message, "error");
      })
      .finally(() => {
        setLoader(false);
        setIsManualLoading(false);
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsManualLoading(true);
    if (couponData?.couponCode === couponText) {
      handleRemovecoupon(couponText);
    } else {
      handleCouponState(null, couponText);
    }
  };

  // ── Drawer mode (new right-side panel design) ──────────────────────────────
  if (drawerMode) {
    // index 0 = manual entry row (rendered by CouponPopup separately)
    if (index === 0) {
      return (
        <form onSubmit={handleSubmit} className="cpd-input-row">
          <input
            className="cpd-code-input"
            value={couponText}
            onChange={(ev) => setCouponText(ev.target.value)}
            placeholder="Enter Coupon Code"
            autoFocus
          />
          <button type="submit" className="cpd-apply-btn" disabled={isManualLoading || !couponText || couponText?.trim() === ""}>
            {isManualLoading ? <CircularProgress size={14} sx={{ color: "#fff" }} /> : "Apply"}
          </button>
        </form>
      );
    }

    // Coupon list item
    if (!e) return null;
    const isApplied = couponData?.couponCode === e?.couponCode;

    return (
      <div className="cpd-coupon-row">
        <div className="cpd-coupon-info">
          <span className="cpd-coupon-name">{e?.couponCode || e?.offerName}</span>
          {e?.description && <span className="cpd-coupon-desc">{e.description}</span>}
          {e?.minOrderValue != null && (
            <span className="cpd-coupon-desc">Add items worth {getStoreCurrencySymbol()}{e.minOrderValue}</span>
          )}
        </div>
        <div className="cpd-coupon-action">
          {loader ? (
            <CircularProgress size={18} sx={{ color: "#0860e6" }} />
          ) : isApplied ? (
            <button className="cpd-remove-btn" onClick={() => handleRemovecoupon()}>
              Remove
              {isExploding && <ConfettiExplosion {...confettiOptions} />}
            </button>
          ) : (
            <button className="cpd-apply-pill" onClick={() => handleCouponState(e?.couponId)}>
              Apply
              {isExploding && <ConfettiExplosion {...confettiOptions} />}
            </button>
          )}
        </div>
      </div>
    );
  }

  // ── Legacy modal mode (unchanged) ──────────────────────────────────────────
  return (
    <>
      {index === 0 && (
        <form onSubmit={handleSubmit} className="coupon-apply-form">
          <BootstrapInput
            value={couponText}
            onChange={(e) => setCouponText(e.target.value)}
            placeholder="Enter Coupon Code"
            fullWidth
            autoFocus
          />
          <div className="coupon-input-wrapper">
            {isManualLoading ? (
              <CircularProgress size={24} />
            ) : (
              <Box>
                {couponData?.couponCode === couponText ? (
                  <button type="submit" className={`${type === "RESTAURANT" ? "button-33-rest-red" : "button-33-red"}`}>
                    Remove<p className="applied-text-red">{getStoreCurrencySymbol()}{couponData?.couponValue}</p>
                  </button>
                ) : (
                  <button type="submit" className={`${type === "RESTAURANT" ? "button-33-rest" : "button-33"}`} disabled={!couponText || couponText?.trim() === ""}>
                    Apply
                    {isExploding && <ConfettiExplosion {...confettiOptions} />}
                  </button>
                )}
              </Box>
            )}
          </div>
        </form>
      )}
      {couponsData?.length === 0 ? (
        <div className="no-coup-data-wrapper-modal">No Coupon Code</div>
      ) : (
        <>
          {errorMsg && <div className="coupon-error-msg"><p>{errorMsg}</p></div>}
          <div className={`${type === "RESTAURANT" ? "coupon-inner-modal-single-box-rest" : "coupon-inner-modal-single-box"}`} key={e?.couponId}>
            <div className="coupon-img-wrapper-box">
              <img className="coupon-img-wrapper-box-img" src={e?.image || defaultImg} alt="err" />
            </div>
            <div className="coupon-text-wrapper-box">
              <h4>{e?.offerName}</h4>
              <p className="coupon-text-wrapper-box-p">{e?.description}</p>
              {type === "RESTAURANT" && (
                <p className="coupon-text-wrapper-box-p">{`Add items worth more than ${getStoreCurrencySymbol()}${e?.minOrderValue ?? "NA"}`}</p>
              )}
            </div>
            <div className="coupon-handle-wrapper-box">
              {loader ? (
                <CircularProgress size={24} />
              ) : (
                <Box>
                  {couponData?.couponCode === e?.couponCode ? (
                    <button className={`${type === "RESTAURANT" ? "button-33-rest-red" : "button-33-red"}`} onClick={() => handleRemovecoupon()}>
                      Remove<p className="applied-text-red">{getStoreCurrencySymbol()}{couponData?.couponValue}</p>
                    </button>
                  ) : (
                    <button className={`${type === "RESTAURANT" ? "button-33-rest" : "button-33"}`} onClick={() => handleCouponState(e?.couponId)}>
                      Apply
                      {isExploding && <ConfettiExplosion {...confettiOptions} />}
                    </button>
                  )}
                </Box>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default memo(PaymentCouponModal);
